<template>
  <div>
    <div class="def-func-table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th class="text-left">
              <span>Checklist Category</span>
            </th>
            <th>
              <span>Function</span>
            </th>
            <th class="text-center">
              <span>Dependencies</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="( result, index ) in checklistResult" :key="index">
            <td>
              <b-form-radio
                name="checklist"
                v-model="checklistIdPassed"
                :value="result.public_id"
                @change="onSelectChecklist( $event, result )"
              />
            </td>
            <td class="text-left">{{ result.title }}</td>
            <td class="text-left">{{ result.fun_title }}</td>
            <td>{{ result.dependencies }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { EventBus } from "../../../main";
export default {
  props: ["checklistResult"],
  data() {
    return {
      checklistIdPassed: ""
    };
  },
  methods: {
    onSelectChecklist(event, result) {
      EventBus.$emit("selectChecklist", result);
    }
  },
  created() {
    EventBus.$on("UnCheckAll", checklistId => {
      this.checklistIdPassed = checklistId;
    });
  },
  beforeCreate() {
    EventBus.$off("UnCheckAll")
  }
};
</script>